"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.date.now");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.object.entries");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var React = __importStar(require("react"));

var react_1 = require("react");

var uniqid_1 = __importDefault(require("uniqid"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var Grid_1 = require("../../atoms/Grid");

var Headline_1 = require("../../atoms/Headline");

var SliderPagination_1 = require("../SliderPagination/SliderPagination");

var SlidesToDisplay;

(function (SlidesToDisplay) {
  /**  Viewport xs and upwards: 3 columns */
  SlidesToDisplay["CONTENT_XS_3"] = "CONTENT_XS_3";
  /**  Viewport xs: 2 columns; sm and upwards: 3 columns  */

  SlidesToDisplay["CONTENT_XS_2"] = "CONTENT_XS_2";
  /**  Viewport xs: 1 column; sm: 2 columns; md and upwards: 3 columns */

  SlidesToDisplay["CONTENT_MD_3"] = "CONTENT_MD_3";
  /**  Viewport xs/sm: 1 column; md and upwards: 2 coluns */

  SlidesToDisplay["CONTENT_MD_2"] = "CONTENT_MD_2";
  /**  Viewport xs and upwards: 1 column */

  SlidesToDisplay["CONTENT_MD_1"] = "CONTENT_MD_1";
  /**  Viewport xs: 1 column; sm/md: 2 columns; lg and upwards: 3 columns */

  SlidesToDisplay["IMG_LG_3"] = "IMG_LG_3";
  /**  Viewport xs: 1 column; md and upwards: 2 columns */

  SlidesToDisplay["IMG_LG_2"] = "IMG_LG_2";
  /**  Viewport xs and upwards: 1 column */

  SlidesToDisplay["IMG_LG_1"] = "IMG_LG_1";
  /** @deprecated;  Viewport xs/sm: 1 column; md: 2 columns; lg and upwards: 3 columns */

  SlidesToDisplay["NEUGELB"] = "NEUGELB";
})(SlidesToDisplay || (SlidesToDisplay = {}));

var numColumns = {
  CONTENT_XS_3: {
    xs: 3
  },
  CONTENT_XS_2: {
    xs: 2,
    sm: 3
  },
  CONTENT_MD_3: {
    xs: 1,
    sm: 2,
    md: 3
  },
  CONTENT_MD_2: {
    xs: 1,
    md: 2
  },
  CONTENT_MD_1: {
    xs: 1
  },
  IMG_LG_3: {
    xs: 1,
    sm: 2,
    lg: 3
  },
  IMG_LG_2: {
    xs: 1,
    md: 2
  },
  IMG_LG_1: {
    xs: 1
  },
  NEUGELB: {
    xs: 1,
    md: 2,
    lg: 3
  }
};
var columnSizes = Object.entries(numColumns).reduce(function (acc, _a) {
  var key = _a[0],
      value = _a[1];
  acc[key] = Object.entries(value).reduce(function (acc2, _a) {
    var key2 = _a[0],
        value2 = _a[1];
    acc2[key2] = 12 / value2;
    return acc2;
  }, {}); // Typescript does not understand this

  return acc;
}, {});

var GallerySlider =
/** @class */
function (_super) {
  __extends(GallerySlider, _super);

  function GallerySlider(props) {
    var _this = _super.call(this, props) || this;

    _this.someElementRef = react_1.createRef();

    _this.addSwipeEventListeners = function () {
      window.addEventListener("mousemove", _this.onMouseMove);
      window.addEventListener("mouseup", _this.onMouseUp);
      window.addEventListener("touchmove", _this.onMouseMove, {
        passive: false
      });
      window.addEventListener("touchend", _this.onMouseUp);
      window.addEventListener("touchcancel", _this.onMouseUp);
    };

    _this.removeSwipeEventListeners = function () {
      window.removeEventListener("mousemove", _this.onMouseMove);
      window.removeEventListener("mouseup", _this.onMouseUp);
      window.removeEventListener("touchmove", _this.onMouseMove);
      window.removeEventListener("touchend", _this.onMouseUp);
      window.removeEventListener("touchcancel", _this.onMouseUp);
    };

    _this.onMouseDown = function (e) {
      _this.addSwipeEventListeners();

      var screenX = _this.getScreenX(e);

      var screenY = _this.getScreenY(e);

      _this.setState({
        mouseDownPositionX: screenX,
        mouseDownPositionY: screenY,
        mouseDownTimestamp: Date.now(),
        animation: false
      });
    };

    _this.onMouseMove = function (e) {
      var screenX = _this.getScreenX(e);

      var screenY = _this.getScreenY(e); // if vertical scroll, abort


      if (_this.state.mouseMovePosition === undefined && Math.abs(_this.state.mouseDownPositionX - screenX) < Math.abs(_this.state.mouseDownPositionY - screenY)) {
        _this.removeSwipeEventListeners();

        _this.setState({
          mouseDownPositionX: undefined,
          mouseDownPositionY: undefined,
          mouseDownTimestamp: undefined,
          mouseMovePosition: undefined,
          animation: true
        });

        return true;
      }

      if (e.cancelable) {
        e.preventDefault();
      }

      if (_this.outerRef) {
        _this.outerRef.style.touchAction = "pan-y pinch-zoom";
        _this.outerRef.style.userSelect = "none";
      }

      _this.setState({
        mouseMovePosition: screenX,
        animation: false
      });

      return false;
    };

    _this.onMouseUp = function (e) {
      _this.removeSwipeEventListeners();

      if (_this.outerRef) {
        _this.outerRef.style.touchAction = "";
        _this.outerRef.style.userSelect = "";
      }

      var screenX = _this.getScreenX(e);

      var velocity = (_this.state.mouseDownPositionX - screenX) / (Date.now() - _this.state.mouseDownTimestamp);

      var movement = _this.state.mouseDownPositionX - screenX;
      var nextSlide = movement / _this.state.elementWidth;

      if (nextSlide > 0.5) {
        _this.handleArrowRightClick();
      } else if (nextSlide < -0.5) {
        _this.handleArrowLeftClick();
      } else if (velocity > 1) {
        _this.handleArrowRightClick();
      } else if (velocity < -1) {
        _this.handleArrowLeftClick();
      }

      _this.setState({
        mouseDownPositionX: undefined,
        mouseDownPositionY: undefined,
        mouseDownTimestamp: undefined,
        mouseMovePosition: undefined,
        animation: true
      });
    };

    _this.onDragStart = function (e) {
      e.preventDefault();
    }; // To determine the width of each Slide, first check the viewport because in different viewport different number
    // of slides will be displayed. Second use the width of displaywindow to divide the number of slides to be displayed
    // and minus the margin of each slide.


    _this.updateSlideWidth = function () {
      var viewport = utils_1.WindowEvents.getViewportSize();
      var foundCurrentViewport = false;
      var slidesToDisplay = 0; // TODO use getMobileFirstValue method

      ["xl", "lg", "md", "sm", "xs"].forEach(function (v) {
        if (viewport === v) {
          foundCurrentViewport = true;
        }

        if (foundCurrentViewport && !slidesToDisplay && numColumns[_this.props.slidesToDisplay][v] !== undefined) {
          slidesToDisplay = numColumns[_this.props.slidesToDisplay][v];
        }
      });

      if (!slidesToDisplay) {
        slidesToDisplay = 1;
      }

      _this.setState({
        slidesToDisplay: slidesToDisplay,
        elementWidth: _this.someElementRef.current ? _this.someElementRef.current.offsetWidth : 0,
        animation: false
      });
    };

    _this.state = {
      currentSlide: _this.props.initialSlide || 0,
      previousSlide: 0,
      slidesToDisplay: 1,
      elementWidth: 0,
      animation: false,
      mouseDownPositionX: undefined,
      mouseDownPositionY: undefined,
      mouseDownTimestamp: undefined,
      mouseMovePosition: undefined
    };
    _this.uuid = props.id || uniqid_1["default"]("lsg--gallery-slider-");
    _this.handlePointClick = _this.handlePointClick.bind(_this);
    _this.handleArrowLeftClick = _this.handleArrowLeftClick.bind(_this);
    _this.handleArrowRightClick = _this.handleArrowRightClick.bind(_this);
    return _this;
  }

  GallerySlider.prototype.componentDidMount = function () {
    utils_1.WindowEvents.addResizeCallback(this.updateSlideWidth);
  };

  GallerySlider.prototype.componentWillUnmount = function () {
    utils_1.WindowEvents.removeResizeCallback(this.updateSlideWidth);
    this.removeSwipeEventListeners();
  };

  GallerySlider.prototype.getScreenX = function (e) {
    return e.screenX || e.changedTouches[0].screenX;
  };

  GallerySlider.prototype.getScreenY = function (e) {
    return e.screenY || e.changedTouches[0].screenY;
  };

  GallerySlider.prototype.handlePointClick = function (nextPage, event) {
    var _this = this;

    if (nextPage >= 0 && nextPage * this.state.slidesToDisplay !== this.state.currentSlide && nextPage * this.state.slidesToDisplay < React.Children.count(this.props.children)) {
      this.setState({
        previousSlide: this.state.currentSlide,
        currentSlide: nextPage * this.state.slidesToDisplay,
        animation: true
      }, function () {
        return _this.props.onChange(_this.state.currentSlide, event);
      });
    }
  };

  GallerySlider.prototype.handleArrowLeftClick = function (event) {
    var _a = this.state,
        currentSlide = _a.currentSlide,
        slidesToDisplay = _a.slidesToDisplay;
    var nextPage = Math.ceil(currentSlide / slidesToDisplay - 1);
    this.handlePointClick(nextPage, event);
  };

  GallerySlider.prototype.handleArrowRightClick = function (event) {
    var _a = this.state,
        currentSlide = _a.currentSlide,
        slidesToDisplay = _a.slidesToDisplay;
    var nextPage = Math.floor(currentSlide / slidesToDisplay + 1);
    this.handlePointClick(nextPage, event);
  };

  GallerySlider.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        children = _a.children,
        title = _a.title,
        titleSize = _a.titleSize,
        slidesToDisplay = _a.slidesToDisplay;
    var _b = this.state,
        previousSlide = _b.previousSlide,
        currentSlide = _b.currentSlide,
        animation = _b.animation;
    var slides = React.Children.count(children);
    var dotCount = this.state.slidesToDisplay !== 0 ? Math.ceil(slides / this.state.slidesToDisplay) : 0;
    var activeDot = Math.floor(this.state.currentSlide / this.state.slidesToDisplay);
    var animationDirection = previousSlide < currentSlide ? 1 : -1;
    var animationOffset = 5 - animationDirection * previousSlide;
    var translate = 100 * this.state.currentSlide + "%";
    var mouseMove = this.state.mouseMovePosition ? this.state.mouseDownPositionX - this.state.mouseMovePosition : 0;

    if (this.someElementRef.current) {
      translate = this.someElementRef.current.getBoundingClientRect().width * this.state.currentSlide + mouseMove + "px";
    }

    return React.createElement("div", {
      id: this.uuid,
      className: CSSPrefix_1.lsgPre + "galleryslider"
    }, React.createElement("div", {
      className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "section-content", CSSPrefix_1.lsgPre + "galleryslider-title"])
    }, React.createElement(Headline_1.Headline, {
      size: titleSize
    }, title)), React.createElement("div", {
      className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "galleryslider-outer", currentSlide > 0 && CSSPrefix_1.lsgPre + "galleryslider-outer__notfirst", animation && CSSPrefix_1.lsgPre + "galleryslider-outer__animate"]),
      onMouseDown: this.onMouseDown,
      onTouchStart: this.onMouseDown,
      onDragStart: this.onDragStart,
      onSelect: this.onDragStart,
      ref: function ref(r) {
        return _this.outerRef = r;
      }
    }, React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "galleryslider-marginal"
    }, "\xA0"), React.createElement(Grid_1.Grid.Row, {
      gap: Grid_1.Grid.Spacing.GALLERY,
      overflow: true,
      verticalAlign: Grid_1.Grid.VerticalAlign.JUSTIFY
    }, React.Children.toArray(children).map(function (child, i) {
      return React.createElement(Grid_1.Grid.Column, __assign({}, columnSizes[slidesToDisplay], {
        style: {
          transform: "translateX(-" + translate + ") translateZ(0)",
          //                                transition: `transform 0.6s`,
          transition: animation ? "transform " + 0.1 * (animationOffset + i * animationDirection) + "s" : "unset"
        },
        elementRef: _this.someElementRef,
        key: child.key,
        className: CSSPrefix_1.lsgPre + "galleryslider-item"
      }), child);
    }))), React.createElement(SliderPagination_1.SliderPagination, {
      numDots: dotCount,
      activeDotIndex: activeDot,
      onPointClick: this.handlePointClick,
      onArrowLeftClick: this.handleArrowLeftClick,
      onArrowRightClick: this.handleArrowRightClick,
      arrowIcon: true
    }));
  };

  GallerySlider.SlidesToDisplay = SlidesToDisplay;
  GallerySlider.defaultProps = {
    initialSlide: 0,
    titleSize: Headline_1.Headline.Sizes.H2,
    slidesToDisplay: SlidesToDisplay.IMG_LG_3,
    onChange: function onChange() {
      /* empty */
    }
  };
  return GallerySlider;
}(React.Component);

exports.GallerySlider = GallerySlider;